import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import { useEffect, useRef, useState } from 'react';
import { borrarConfigPorLista, getAllComunicaConfig } from '../../services/HorarioTurno/TurnoService';

const DatosConfig = () => {
    const [lstConfig, setLstConfig] = useState([]);
    const [cargaConfig, setCargaConfig] = useState(false);
    const [configSelect, setConfigSelect] = useState([]);
    const [procesaBorrado, setProcesaBorrado] = useState(false);
    const [refrescaConfig, setRefrescaConfig] = useState(false);

    const myToast = useRef();

    useEffect(() => {
        const recuperaConfiguraciones = async () => {
            try {
                setCargaConfig(true);
                const configs = await getAllComunicaConfig();
                //console.log ('WW0=', configs)
                setLstConfig(configs);
            } catch (err) {
                console.error('Error: ', err.message);
            } finally {
                setCargaConfig(false);
            }
        };
        recuperaConfiguraciones();
    }, [refrescaConfig]);

    // filtros
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        proyectoSigla: { value: null, matchMode: 'contains' },
        proyectoNombre: { value: null, matchMode: 'contains' },
        puestoSigla: { value: null, matchMode: 'contains' },
        puestoNombre: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        proyectoSigla: '',
        proyectoNombre: '',
        puestoSigla: '',
        puestoNombre: '', 
        global: ''
    });

    const limpiarFiltros = () => {
        setValoresFiltros({
            proyectoSigla: '',
            proyectoNombre: '', 
            puestoSigla: '',
            puestoNombre: '',
            global: ''
        });

        setFiltros({
            global: { value: null, matchMode: 'contains' },
            proyectoSigla: { value: null, matchMode: 'contains' },
            proyectoNombre: { value: null, matchMode: 'contains' },
            puestoSigla: { value: null, matchMode: 'contains' },
            puestoNombre: { value: null, matchMode: 'contains' }
        });
    };

    // filtro para Texto
    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    const handleBorrar = async () => {
        //console.log('XX0=', configSelect);
        if (configSelect.length === 0) {
            myToast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Debe seleccionar alguna Configuracion', life: 3000 });
            return;
        }
        try {
            setProcesaBorrado(true);
            const listaIds = configSelect.map((item) => item.comunicaConfigId);
            const respuesta = await borrarConfigPorLista(listaIds);
            myToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Se ha Eliminado la configuracion con Exito', life: 3000 });
            setConfigSelect ([])
            setLstConfig([])
            setRefrescaConfig(prev => !prev)
        } catch (err) {
            console.error('Error: ', err.message);
            myToast.current.show({ severity: 'error', summary: 'Error', detail: 'No se han eliminado', life: 3000 });
        } finally {
            //
            setProcesaBorrado(false);
        }
    };

    return (
        <div className="card">
            <h5>Informe de Configuraciones</h5>
            <Toast ref={myToast} />
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-11">
                    <DataTable
                        value={lstConfig}
                        loading={cargaConfig}
                        selectionMode="checkbox"
                        selection={configSelect}
                        onSelectionChange={(e) => setConfigSelect(e.value)}
                        dataKey="comunicaConfigId"
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 15, 20]}
                        filters={filtros}
                        filterDisplay="row"
                        emptyMessage="No se encontraron resultados."
                        size="small"
                        stripedRows
                        scrollable
                        tableStyle={{ minWidth: '90rem', width: '100%' }}
                    >
                        <Column selectionMode="multiple" style={{ width: '1%' }}></Column>
                        <Column header="Proyecto Sigla" field="proyectoSigla" filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'proyectoSigla')} showFilterMenu={false} style={{ width: '17%' }}></Column>
                        <Column header='Proyecto Nombre' field='proyectoNombre' filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'proyectoNombre')} showFilterMenu={false} style={{ width: '18%' }}></Column>
                        <Column header="Puesto Sigla" field="puestoSigla" filter filterPlaceholder="Filtro Puesto" filterElement={(options) => textoFilterTemplate(options, 'puestoSigla')} showFilterMenu={false} style={{ width: '18%' }}></Column>
                        <Column header='Puesto Nombre' field='puestoNombre' filter filterPlaceholder="Filtro Proyecto" filterElement={(options) => textoFilterTemplate(options, 'puestoNombre')} showFilterMenu={false} style={{ width: '18%' }}></Column>
                        <Column header="Horario" field="horarioDescripcion" style={{ width: '5%' }}></Column>
                        <Column header="Intervalo" field="horarioDetalle" style={{ width: '4%' }}></Column>
                        <Column header="Dias" field="dias" style={{ width: '3%' }}></Column>
                        <Column header="Cantidad" field="cantidadVeces" style={{ width: '4%' }}></Column>
                        <Column header="Aleatorio" field="esAleatorio" style={{ width: '4%' }}></Column>
                        <Column header="Lim Inf." field="limInf" style={{ width: '4%' }}></Column>
                        <Column header="Lim Sup." field="limSup" style={{ width: '4%' }}></Column>
                    </DataTable>
                </div>
                <div className="field col-12 md:col-1">
                    <Button label="Eliminar" onClick={handleBorrar} loading={procesaBorrado}></Button>
                </div>
            </div>
        </div>
    );
};

export default DatosConfig;
